import React from 'react';
import { Clickable, Text } from '@moda/om';
import SocialPhoneIcon from '@moda/icons/social-phone-16';
import SocialFacebookIcon from '@moda/icons/social-facebook-16';
import SocialInstagramIcon from '@moda/icons/social-instagram-16';
import SocialPinterestIcon from '@moda/icons/social-pinterest-16';
import SocialTwitterIcon from '@moda/icons/social-twitter-16';
import { useCountry } from '../../CountrySelector';

import './SiteFooterBasement.scss';

export const SiteFooterBasement: React.FC = () => {
  const { country } = useCountry();
  const showPrivacyChoicesLink = country.alpha2Code === 'US';

  return (
    <section className="SiteFooterBasement">
      <a
        className="SiteFooterInlineItem"
        data-test-id="download-the-moda-app"
        href="https://itunes.apple.com/us/app/moda-operandi/id781702094"
        target="_blank"
        rel="noopener noreferrer"
      >
        <SocialPhoneIcon className="SiteFooterDesktop__icon" />
        Download the Moda App
      </a>

      <div className="SiteFooterInlineItem">
        <a
          href="https://www.instagram.com/modaoperandi/"
          data-test-id="moda-on-ig"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Moda Operandi on Instagram"
        >
          <SocialInstagramIcon className="SiteFooterDesktop__icon" />
        </a>

        <a
          href="https://www.facebook.com/ModaOperandi"
          target="_blank"
          data-test-id="moda-on-fb"
          rel="noopener noreferrer"
          aria-label="Moda Operandi on Facebook"
        >
          <SocialFacebookIcon className="SiteFooterDesktop__icon" />
        </a>

        <a
          href="https://twitter.com/modaoperandi"
          target="_blank"
          data-test-id="moda-on-twitter"
          rel="noopener noreferrer"
          aria-label="Moda Operandi on Twitter"
        >
          <SocialTwitterIcon className="SiteFooterDesktop__icon" />
        </a>

        <a
          href="https://www.pinterest.com/modaoperandi"
          target="_blank"
          data-test-id="moda-on-pinterest"
          rel="noopener noreferrer"
          aria-label="Moda Operandi on Pinterest"
        >
          <SocialPinterestIcon className="SiteFooterDesktop__icon" />
        </a>
      </div>

      <a className="SiteFooterInlineItem" data-test-id="terms-and-conditions" href="/terms">
        Terms &amp; Conditions
      </a>

      <a className="SiteFooterInlineItem" data-test-id="privacy-policy" href="/privacy">
        Privacy Policy
      </a>

      {showPrivacyChoicesLink && (
        <Clickable
          className="SiteFooterInlineItem"
          href="#"
          onClick={() => window.evidon.notice.showOptions()}
        >
          <Text treatment="body2">Your Privacy Choices</Text>
        </Clickable>
      )}

      <a className="SiteFooterInlineItem" data-test-id="terms-and-conditions" href="/legal">
        Legal
      </a>

      <div data-test-id="moda-copyright" className="SiteFooterInlineItem">
        © {new Date().getFullYear()} Moda Operandi, Inc. All Rights Reserved.
      </div>
    </section>
  );
};
